import { atomFamily } from "jotai/utils";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

const sessionTosAcceptedAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`tosAccepted-${sessionId}`, false)
);

export const tosAcceptedAtom = createDerivedSessionAtom<boolean>(sessionTosAcceptedAtom);
